window.$ = require('jquery');
import ScrollReveal from 'scrollreveal';
/* import Rellax from 'rellax'; */
import Swiper from 'swiper';
import ScrollMagic from 'scrollmagic';
import { TweenMax } from "gsap/TweenMax";
import fancybox from "@fancyapps/fancybox";

$(document).ready(function () {

 /*  ScrollReveal().reveal('.section', {
    beforeReveal: function (el) {
      $(el).addClass("activeAnim");
    }
  }); */

/*   if ($('.section-service .rellax').length > 0) {
    new Rellax('.section-service .rellax', {
      center: true
    });
  } */


  var activeHeader = function () {
    var winPos = $(window).scrollTop();
    if (winPos > 80) {
      $("header").addClass("header-active");
    } else {
      $("header").removeClass("header-active");
    }
  };
  activeHeader();
  $(window).scroll(function () {
    activeHeader();
  });

  $(".hamburger").click(function (event) {
    $(this).toggleClass("h-active");
    $("body").toggleClass("main-nav-active");
  });

  $(".main-nav .fl").on('click', function (event) {
    var $fl = $(this);
    $(this).parent().siblings().find('.submenu').slideUp();
    $(this).parent().siblings().find('.fl').addClass('plus').text("+");
    if ($fl.hasClass('plus')) {
      $fl.removeClass('plus').addClass('minus').text("-");
    } else {
      $fl.removeClass('minus').addClass('plus').text("+");
    }
    $fl.next(".submenu").slideToggle();
  });

  var heroslider = new Swiper('.heroSlide', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000
    },
    on: {
      init: function () {
      }
    }
  });

  heroslider.on('slideChangeTransitionStart', function () {
  });

  var swiper = new Swiper('.two-grid', {
    slidesPerView: 2,
    roundLengths: true,
    centerInsufficientSlides: true,
    spaceBetween: 50,
    autoplay: {
      delay: 5000
    },
    speed: 1000,
    navigation: {
      nextEl: '.eventslider-next',
      prevEl: '.eventslider-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1
      }
    }
  });

  var swiper = new Swiper('.multi-slider', {
    slidesPerView: 4,
    centerInsufficientSlides: true,
    roundLengths: true,
    autoplay: {
      delay: 5000
    },
    speed: 1000,
    navigation: {
      nextEl: '.multi-next',
      prevEl: '.multi-prev'
    },
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2
      },
      420: {
        slidesPerView: 1
      }
    }
  });

  if ($(".ps-thumb .swiper-slide").length > 1){
    var postThumbs = new Swiper('.ps-thumb', {
      spaceBetween: 10,
      slidesPerView: 6,
      resistanceRatio: 0.40,
      centeredSlides: $(".ps-thumb .swiper-slide").length > 6 ? true : false,
      centerInsufficientSlides: true,
      loop: $(".ps-thumb .swiper-slide").length > 6 ? true : false,
      // freeMode: true,
      watchSlidesProgress: true,
      loopAdditionalSlides: 1,
      // slideToClickedSlide: true,
      breakpoints: {
        575: {
          slidesPerView: 3
        }
      }
    });

    new Swiper('.ps-big', {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: postThumbs
      }
    });
  }else{
    $(".ps-thumb").hide();
  }
  // Post Slider
  var diaryslider = [];
  $(".diary-wrap").each(function (val, index) {
    var $this = $(this);
    diaryslider[index] = new Swiper($this.find(".diary-slider"), {
      spaceBetween: 35,
      slidesPerView: 3,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: $this.find(".diary-button-next"),
        prevEl: $this.find(".diary-button-prev"),
      },
      breakpoints: {
        991: {
          slidesPerView: 2
        },
        767: {
          slidesPerView: 1
        }
      }
    });
    if($(window).width()>1199){
      if ($this.find(".diary-slider .swiper-slide").length < 4){
        $this.find(".diary-button-next").hide();
        $this.find(".diary-button-prev").hide();
        $this.find(".diary-slider .swiper-pagination").hide();
      }
    }
  });
  // Trustee hovered text clone;
  $(".hover-card").each(function(){
     var $content =  $(this).find(".hover-text").html();
     $(this).find(".card-body").append('<div class="d-xl-none h-body-text">'+$content+'</div>');
  });

  // Tabs script
  $(".tabs:not(.hasLink) ul li a").on(" click",function(e){
    e.preventDefault();
    $(this).parent("li").addClass("active-tab").siblings().removeClass("active-tab");
    var $id = $(this).data("tab-id");
    $(this).parents(".tabs").next(".tabs-container").find($id).fadeIn(300).siblings().hide();
  });

  // Input file Name

  $('input[type="file"]').on("change", function(e){
    var fName = $(this).val().split('\\').pop();
    $(this).next(".custom-file-label").html(fName);
  });

  /* $('.animfadeIn').not(".animCompleted").each(function () {
    $(this).css
    var animdur = $(this).data("animdur") || 1;
    var hook = $(this).data("hook") || 0.8;
    ScrollReveal().reveal($(this), {
      easing: "ease-in",
      distance: '15px',
      duration: 1000,
      afterReveal: function (el) {
        $(el).addClass("animCompleted");
      }
    });
  }); */
  ScrollReveal().reveal('.animfadeIn', {
    easing: "ease-in",
      distance: '15px',
    duration: 1000
  });

  ScrollReveal().reveal('.staggerFade', {
    easing: "ease-out",
    opacity: 0,
    duration: 700,
    viewFactor: 0.3,
    delay: 200,
    interval: 80
  });

  $(".search-btn").on('click', function (event) {
    $(".searchbox").fadeToggle();
    if ($(this).find("i").hasClass('flaticon-search')) {
      $(this).find("i").removeClass('flaticon-search').addClass("flaticon-close");
    }
    else {
      $(this).find("i").removeClass('flaticon-close').addClass("flaticon-search");
    }
  });
  $(window).click(function () {
    if ($(".search-btn i").hasClass('flaticon-close')) {
      $(".searchbox").fadeToggle();
      $(".search-btn i").removeClass('flaticon-close').addClass("flaticon-search");
    }
  });
  $('.searchbox, .search-btn').click(function (event) {
    event.stopPropagation();
  });

  $('[data-fancybox="gallery"]').fancybox({
    buttons: [
      "zoom",
      "close"
    ],
  });

}); //document ready end


$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    if ($(".search-btn i").hasClass('flaticon-close')) {
      $(".searchbox").fadeToggle();
      $(".search-btn i").removeClass('flaticon-close').addClass("flaticon-search");
    }
  }
});


$(window).on('load', function () {

  CSSPlugin.defaultForce3D = false;
  var tl = new TimelineMax({ repeat: 0 });

  var easeIn = Power0.easeIn,
  easeOut = Power0.easeOut,
  easeInOut = Power0.easeInOut,
  elastic = Elastic.easeOut.config(1, 0.3);

  tl.staggerTo('.brand img', 0.5, { autoAlpha: 1, visibility: "visible", scale: 1 }, 0);

});

console.log("%cImpact Deisgn Solutions", "color: white; background: black; padding: 2px 20px; font-size: 13px");


if ($(window).width() < 1199){
  var headerheight = $("header.header-main").innerHeight();
  var activeHeader = function () {
    var winPos = $(window).scrollTop();
    if (winPos > headerheight) {
      $(".navigation").addClass("navigation-active");
    } else {
      $(".navigation").removeClass("navigation-active");
    }
  };
  activeHeader();
  $(window).scroll(function () {
    activeHeader();
  });
}

/* console.log("hjashg"); */